// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-ZXz","tabsBox":"styles_tabsBox__36cay","createButton":"styles_createButton__1fJGp"};